import {useState} from 'react';
import {Link, NavLink} from 'react-router-dom'
import Logo from '../images/logo_aliquam.png'
import Logo2 from '../images/logo_aliquam2.png'
import {links} from '../data'
import {GoThreeBars} from 'react-icons/go'
import {MdOutlineClose} from 'react-icons/md'
import './Navbar.css'
import '../pages/home/About'


const Navbar = () => {
    const [isNavShowing, setIsNavShowing] = useState(false)
    const [navbar, setNavbar] = useState(false)

    const changeBackground = () => {
        if(window.scrollY >= 100) {
            setNavbar(true)
        }else{
            setNavbar(false)
        }
    }

    const handleNavLinkClick = () => {
        window.scrollTo(0, 0); 
      };

    window.addEventListener('scroll', changeBackground)

  return (
    <nav className={navbar ? 'active' : ''}>
        <div className="container nav__container">
            <Link to="/" className="logo" onClick={() => setIsNavShowing(false)}>
                <img src={Logo} alt="Logo"/>
            </Link>
            <Link to="/" className="logo2" onClick={() => setIsNavShowing(false)}>
                <img src={Logo2} alt="Logo2"/>
            </Link>
            <ul className={`nav__links ${isNavShowing ? 'show__nav' : 'hide__nav'}`}>
            <li>
                 <a href='/#about'>About us</a>
            </li>
            {
                links.map(({name, path, target}, index) => {
                    return (
                        <li key={index}>
                        {target ? (
                          <a href={path} target={target} rel="noopener noreferrer">
                            {name}
                          </a>
                        ) : (
                          <NavLink
                            to={path}
                            activeclassname="active-nav"
                            onClick={handleNavLinkClick}>
                            {name}
                          </NavLink>
                        )}
                      </li>
                    )
                })
            }
            </ul>
            <button className="nav__toggle-btn" onClick={() => setIsNavShowing(prev => !prev)}>
                {
                    isNavShowing ? <MdOutlineClose/>: <GoThreeBars/>
                }
            </button>
        </div>
    </nav>
  )
}

export default Navbar